import {Component, OnDestroy, OnInit} from '@angular/core';
import {IconComponent} from '../../../elements/icon/icon.component';
import {Icons} from '../../../../model/icon';
import {Location, NgForOf} from '@angular/common';
import {Router} from '@angular/router';
import {MenuService} from '../../../../services/menu-services';
import {scrollUp} from '../../../../functions/scroll-up';
import {ScrollService} from '../../../../services/scroll-service';
import {LocalizationService} from '../../../../services/localization.service';
import {LocationDto} from '../../../../model/continent';
import {findFirstContinent, findFirstCountry} from '../../../../functions/findFirstCityUrl';
import {RouteService} from '../../../../services/route-service';
import {TextsComponent} from '../../../elements/texts/texts.component';

export interface NewMobileMenuEl {
  titleRu: string;
  titleEn: string;
  url?: string;
}

@Component({
  selector: 'app-new-mobile-menu',
  imports: [
    IconComponent,
    NgForOf,
    TextsComponent
  ],
  templateUrl: './new-mobile-menu.component.html',
  styleUrl: './new-mobile-menu.component.scss'
})

export class NewMobileMenuComponent implements OnInit, OnDestroy{
  constructor(public location: Location,
              private router: Router,
              protected menuService: MenuService,
              protected scrollService: ScrollService,
              protected localizationService: LocalizationService,
              protected routeService: RouteService,) {}

  elements: NewMobileMenuEl[] = [
    // {
    //   title: 'Main',
    //   url: '/'
    // },
    {
      titleEn: 'Destinations',
      titleRu: 'Направления',
      url: '/destinations'
    },
    {
      titleEn: 'Services',
      titleRu: 'Услуги',
      url: '/services'
    },
    {
      titleEn: 'Adventures',
      titleRu: 'Путешествия',
      url: '/adventures'
    },
    // {
    //   titleEn: 'Get in Touch',
    //   titleRu: 'Get in Touch',
    //   url: '/feedback'
    // },
    {
      titleEn: 'travel ideas',
      titleRu: 'Уникальные места',
      url: 'travel'
    },
  ];

  ngOnInit() {
    this.scrollService.lockScroll();
  }

  ngOnDestroy() {
    this.scrollService.unlockScroll();
  }

  onClick(el: NewMobileMenuEl) {
    if (el.url !== undefined) {
      if (el.url === 'travel') {
        this.onClickDiscover();
        return;
      }
      scrollUp();
      this.router.navigate([el.url]).then(r => r);
      this.menuService.setMobileActive(false);
    }
    return
  }

  openUrl(url: string) {
    scrollUp();
    this.router.navigate([url]).then(r => r);
    this.menuService.setMobileActive(false);
  }

  onClickDiscover() {
    this.menuService.setMobileActive(false);
    const randomRoute = this.routeService.getRandom();
    const findCountry: LocationDto | undefined = findFirstCountry(randomRoute.points);
    if (findCountry === undefined) {
      return;
    }
    const country = findCountry.url
    const findContinent: LocationDto | undefined = findFirstContinent(randomRoute.points);
    if (findContinent === undefined) {
      return;
    }
    const continent = findContinent.url;
    this.router.navigate([`/destinations/${continent}/${country}/route/${randomRoute.url}`]).then(r => r);
    setTimeout(() => this.routeService.setRandom(), 10);
  }


  protected readonly Icons = Icons;
}
